<template>
  <v-card class="rounded-b-0">
    <v-card-title class="align-start">
      <span>Tissue Category</span>

      <v-spacer></v-spacer>

     
    </v-card-title>

    <v-card-text>
      
     
       <div id="pie-chart"></div>
     
    </v-card-text>
  </v-card>
</template>

<script>

import { mdiDotsVertical, mdiTrendingUp, mdiCurrencyUsd } from '@mdi/js'
import { getCurrentInstance } from '@vue/composition-api'
import daskboardserice from '@/service/Dashboard.service'
import moment from 'moment'
export default {

  setup() {
    

    return {

      icons: {
        mdiDotsVertical,
        mdiTrendingUp,
        mdiCurrencyUsd,
      },
    }
  },
   
   
   watch: {
    options: {
      handler() {
        this.chartMap()
      },
      deep: true,
    },
  },
  mounted() {
    this.chartMap()

  },
  methods:{

    async chartMap(){
      const service = new daskboardserice()
      let response = await service.getDaskboard()
     
      var data12 = response
       console.log("hello", data12.weekly_optical)
      var optical = data12.weekly_optical
      var therapeutic = data12.weekly_therapeutic
     
      const arr =[]
      arr[0]=optical
      arr[1]=therapeutic

    
      var options = {
          series: arr,
          chart: {
          width: 385,
          type: 'pie',
        },
        colors:['#00e396','#1bbc9b'],
        labels: ['Optical', 'Therapeutic '],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
        };

        var pir_chart = new ApexCharts(document.querySelector("#pie-chart"), options);
        pir_chart.render();
    }
  }
}
</script>
